import { ColDef, ColGroupDef } from 'ag-grid-community';
import { BasePermissionGrid } from '../Grids/PermissionGrids/BasePermissionGrid';
import { RecordPropertyRole } from '../RolePanelTypes';

export class RecordPropertyRolesGrid extends BasePermissionGrid<RecordPropertyRole> {
    id: string = 'RecordPropertyRoles';
    gridClass: string = 'recordPropertyRolesGrid';

    protected endpoint: string = '/rolePanel/recordPropertyRoles';

    protected getColumnDefs(): (ColDef<any, any> | ColGroupDef<any>)[] {
        return [
            {
                field: 'PropertyName',
                headerName: 'Properties',
                flex: 3,
                resizable: false,
                cellRendererParams: { disabled: false },
            },
            {
                field: 'AllowEdit',
                flex: 1,
                resizable: false,
                cellRendererParams: { disabled: false },
            },
            {
                field: 'IsVisible',
                flex: 1,
                resizable: false,
                cellRendererParams: { disabled: false },
            },
        ];
    }
}
